import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Import theme provider
import { ThemeProvider } from './context/ThemeContext';

// Import pages
import Home from './pages/Home';
import Services from './pages/Services';
import Team from './pages/Team';
import About from './pages/About';
// import Customers from './pages/Customers';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import TeamMemberProfile from './pages/TeamMemberProfile';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="flex flex-col min-h-screen dark:bg-gray-900 dark:text-white transition-colors duration-300">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/customers" element={<Customers />} /> */}
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/:memberId" element={<TeamMemberProfile />} />
          </Routes>
        </main>
        <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
